import { AnyAction, combineReducers } from "redux";
import { ActionTypes as AuthorizationActionTypes } from "../actions/common/session/types";
import AppStateInterface from "../interfaces/AppStateInterface";
import { currentSection } from "./common/currentSection";
import errors from "./common/errors";
import { operatorPrivileges } from "./common/operatorPrivileges";
import session from "./common/session";
import flashMessage from "./flashMessage";
import studentLearningMaterialsPreRegistrations from "./pages/StudentsLearningMaterialsPreRegistrationsPage";
import sectionLearningMaterialEditState from "./sectionLearningMaterialEditState";
import sectionLearningMaterialNewState from "./sectionLearningMaterialNewState";
import sectionOperatorInvitations from "./sectionOperatorInvitations";
import student from "./student";

// FIXME: エラーメッセージは要相談
export const HTTP_ERROR_MESSAGE =
  "通信エラーです。しばらくしてから再読込してください。";

const shouldReload = (state = false, action: ReduxActions.Action<any>) => {
  switch (action.type) {
    case AuthorizationActionTypes.SIGN_OUT:
      return true;
    default:
      return state;
  }
};

// FIXME: ReduxActions.Action<any> で統一したい
const combinedReducer = combineReducers<AppStateInterface, any>({
  session,
  currentSection,
  student,
  flashMessage,
  shouldReload,
  sectionOperatorInvitations,
  sectionLearningMaterialNewState,
  sectionLearningMaterialEditState,
  errors,
  operatorPrivileges,
  studentLearningMaterialsPreRegistrations,
});

export default (
  state: AppStateInterface | undefined,
  action: AnyAction,
): AppStateInterface => {
  if (action.type === "redux/RESET_STATE") {
    if (state && state.session) {
      return {
        ...combinedReducer(undefined, action),
        session: state.session,
        flashMessage: state.flashMessage,
      };
    }
  }

  if (action.type === "redux/CLEAR_STATE") {
    state = undefined;
  }

  return combinedReducer(state, action);
};
